import { formatNumber } from '../../../index.js';
import { TribunalCaseType } from '../../cases/types.js';
export var GLTribunalJobType;
(function (GLTribunalJobType) {
    GLTribunalJobType["CreateStaevning"] = "CREATE_STAEVNING";
    GLTribunalJobType["ResendStaevning"] = "RESEND_STAEVNING";
    GLTribunalJobType["RegisterVerdict"] = "REGISTER_VERDICT";
    GLTribunalJobType["CreateFogedbegaering"] = "CREATE_FOGEDBEGAERING";
    GLTribunalJobType["ResendFogedbegaering"] = "RESEND_FOGEDBEGAERING";
    GLTribunalJobType["RegisterInsolvens"] = "REGISTER_INSOLVENS";
    GLTribunalJobType["GLCreateBetalingspaakrav"] = "GL_CREATE_BETALINGSPAAKRAV";
    GLTribunalJobType["GLResendBetalingspaakrav"] = "GL_RESEND_BETALINGSPAAKRAV";
})(GLTribunalJobType || (GLTribunalJobType = {}));
export const tribunalGLJobReferenceCaseMap = {
    [GLTribunalJobType.CreateStaevning]: [TribunalCaseType.GLStaevning],
    [GLTribunalJobType.ResendStaevning]: [TribunalCaseType.GLStaevning],
    [GLTribunalJobType.RegisterVerdict]: [TribunalCaseType.GLStaevning],
    [GLTribunalJobType.CreateFogedbegaering]: [TribunalCaseType.GLFogedBegaering],
    [GLTribunalJobType.ResendFogedbegaering]: [TribunalCaseType.GLFogedBegaering],
    [GLTribunalJobType.RegisterInsolvens]: [TribunalCaseType.GLFogedBegaering],
    [GLTribunalJobType.GLCreateBetalingspaakrav]: [
        TribunalCaseType.GLBetalingspaakrav,
    ],
    [GLTribunalJobType.GLResendBetalingspaakrav]: [
        TribunalCaseType.GLBetalingspaakrav,
    ],
};
export const toPDFData = (staevningData) => {
    return {
        ...staevningData,
        courtFee: formatNumber(staevningData.courtFee),
        interests: formatNumber(staevningData.interests),
        totalAmount: formatNumber(staevningData.totalAmount),
    };
};
//# sourceMappingURL=greenland.js.map